module.exports = __webpack_public_path__ + "0241a1cb0e01b7eae247968cdac0dac9.jpg";